import Button from "@web-ui/components/Button";
import Meter from "@web-ui/components/Meter";
import type { Budget } from "@/api/admin";
import { bytes } from "@/lib/format";

/** Storage used of the brand's budget, a small card that leads to Files (Needs attention says so too once it is over 80 %). */
export function StorageCard({ budget, loading, filesHref }: { budget: Budget | null; loading: boolean; filesHref: string }) {
  const used = budget ? budget.storedBytes + budget.reservedBytes : 0;
  const share = budget && budget.budgetBytes > 0 ? used / budget.budgetBytes : 0;
  return (
    <section className="card flex flex-col gap-3" aria-labelledby="storage">
      <div className="flex items-center gap-3">
        <h2 id="storage" className="me-auto text-sub-title-1 ps-card-inset">Storage</h2>
        <Button as="a" variant="ghost" size="sm" href={filesHref}>See files</Button>
      </div>
      <div className="px-card-inset pb-2">
        {loading ? <p className="text-body-2 text-t-secondary" aria-busy="true">Loading…</p>
          : budget ? <Meter value={used} max={budget.budgetBytes} label="Videos and images" figure={`${bytes(used)} of ${bytes(budget.budgetBytes)}`} tone={share >= 0.95 ? "critical" : share > 0.8 ? "warning" : undefined} note={`${bytes(budget.freeBytes)} free`} />
          : <p className="text-body-2 text-t-secondary">Storage is not available right now.</p>}
      </div>
    </section>
  );
}
